import HotelLanding from "@/components/HotelLanding/HotelLanding";
import React from "react";
import ReactDOM from "react-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function mountHotelLanding() {
  const el = document.getElementById("hotel-landing");
  const propsScript = document.getElementById("hotel-landing-props");

  if (el && !el.dataset.reactMounted && propsScript) {
    try {
      const props = JSON.parse(propsScript.textContent || "{}");
      ReactDOM.render(React.createElement(HotelLanding, props), el);
      el.dataset.reactMounted = "true";
    } catch (e) {
      console.error("Failed to parse props JSON:", e);
    }
  }
}

document.addEventListener("turbo:render", mountHotelLanding);
document.addEventListener("DOMContentLoaded", mountHotelLanding);
mountHotelLanding();
